import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-c6a5c7c8"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "common-header"
}, null, -1));
import api from "@/api/shipin2/index.js";
import { onMounted, ref } from "vue";
import { useIndexStore } from "../store";
import { storeToRefs } from 'pinia';
export default {
  __name: 'CommonHeader',
  setup(__props) {
    const userIndex = useIndexStore();
    const {
      config,
      notice
    } = storeToRefs(userIndex);
    const oldScrollTop = ref(0);
    const isHide = ref(false);
    const scrollTop = ref(0);
    const scrolling = event => {
      scrollTop.value = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;

      // 设置上边界 未超过显示
      if (scrollTop.value < 87) {
        return isHide.value = false;
      }

      // 设置下边界 滑动到下边界后隐藏顶部 
      if (scrollTop.value + document.documentElement.clientHeight >= document.body.scrollHeight - 100) {
        return isHide.value = true;
      }

      // 滚动条滚动的距离
      let scrollStep = scrollTop.value - oldScrollTop.value;

      // 更新——滚动前，滚动条距文档顶部的距离
      oldScrollTop.value = scrollTop.value;
      if (scrollTop.value + document.documentElement.clientHeight === document.body.scrollHeight) {
        return isHide.value = false;
      }
      if (scrollStep < 0) {
        isHide.value = false;
      } else {
        isHide.value = true;
      }
    };
    window.addEventListener("scroll", scrolling);
    onMounted(() => {
      isHide.value = false;
    });
    return (_ctx, _cache) => {
      const _component_HeaderNav = _resolveComponent("HeaderNav");
      const _component_CategoryNav = _resolveComponent("CategoryNav");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
        class: _normalizeClass([{
          isHide: isHide.value
        }, "home-fixed"])
      }, [_createVNode(_component_HeaderNav), _createVNode(_component_CategoryNav, {
        ref: "cateRed"
      }, null, 512)], 2), _hoisted_1], 64);
    };
  }
};